import { memo } from 'react'
import Head from 'next/head'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './index.module.scss'

const BreadCrumb = memo((props) => {
  const { className, breadcrumb, breadcrumbHead, addHead } = props

  if (!breadcrumb || !breadcrumb.length) return null

  return (
    <>
      {addHead && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbHead) }}
          />
        </Head>
      )}
      <div className={classNames('container', styles.breadcrumbContainer)}>
        <div className={classNames(styles['breadcrumb'], styles[className])}>
          <ol data-test="breadcrumb">
            {breadcrumb?.map((item, index) => {
              return (
                <li data-test="item" key={index}>
                  {item?.url ? (
                    <a data-test="link" href={item?.url}>
                      {item?.text}
                    </a>
                  ) : (
                    <span data-test="current-page">{item?.text}</span>
                  )}
                </li>
              )
            })}
          </ol>
        </div>
      </div>
    </>
  )
})

BreadCrumb.propTypes = {
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  className: PropTypes.string,
}

BreadCrumb.defaultProps = {
  breadcrumb: [],
  className: '',
}

export default BreadCrumb
